var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 0.833252C11.9553 0.833252 15.1666 4.04459 15.1666 7.99992C15.1666 11.9553 11.9553 15.1666 7.99998 15.1666C4.04465 15.1666 0.833313 11.9553 0.833313 7.99992C0.833313 4.04459 4.04465 0.833252 7.99998 0.833252ZM7.99998 1.83325C4.59665 1.83325 1.83331 4.59659 1.83331 7.99992C1.83331 11.4033 4.59665 14.1666 7.99998 14.1666C11.4033 14.1666 14.1666 11.4033 14.1666 7.99992C14.1666 4.59659 11.4033 1.83325 7.99998 1.83325Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9586 7.08848C11.2926 7.27048 11.5 7.61981 11.5 7.99981C11.5 8.37981 11.2926 8.72915 10.9593 8.91115L6.70196 11.2331C6.37996 11.4085 5.98996 11.4018 5.67463 11.2145C5.35996 11.0278 5.16663 10.6885 5.16663 10.3218V5.67781C5.16663 5.31115 5.35996 4.97181 5.67463 4.78515C5.98996 4.59781 6.37996 4.59115 6.70196 4.76648L10.9586 7.08848ZM10.48 7.96648L6.22263 5.64448C6.21129 5.63781 6.19663 5.63781 6.18529 5.64515C6.17396 5.65181 6.16663 5.66448 6.16663 5.67781V10.3218C6.16663 10.3351 6.17396 10.3478 6.18529 10.3545C6.19663 10.3618 6.21129 10.3618 6.22329 10.3551L10.48 8.03315C10.4926 8.02648 10.5 8.01381 10.5 7.99981C10.5 7.98581 10.4926 7.97315 10.48 7.96648Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.2f0ce73b10e9857e980f5b3072036e98.svg";
export { ForwardRef as ReactComponent };